const BASE = String(process.env.REACT_APP_SPRING_BOOT_API_URL || "").replace(/\/+$/, "");

export async function getMe(token?: string | null): Promise<any> {

    const headers: Record<string, string> = {};
    if (token) headers.Authorization = `Bearer ${token}`;

    const res = await fetch(`${BASE}/api/me`, { headers });
    if (!res.ok) throw new Error(`GET /me failed: ${res.status}`);
    return res.json();
}

export async function updateSettings(settings: Record<string, string>, token?: string | null): Promise<any> {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    const res = await fetch(`${BASE}/api/me/settings`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(settings)
    });
    if (!res.ok) throw new Error(`PUT /me/settings failed: ${res.status}`);
    return res.json();
}